import { makeStyles } from '@material-ui/core';

export const useEvaluationTemplateStyles = makeStyles(theme => ({
  submitButtonGrid: {
    textAlign: 'center',
    marginTop: 50,
  },
  button: {
    margin: theme.spacing(1),
  },
  textField: {
    width: 600,
  },
  pageTitleGrid: {
    textAlign: 'start',
    marginBottom: 50,
  },
}));
